var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPodcast = function SvgPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M6.166 6.166A8.25 8.25 0 0 1 20.25 12v1.25H18A2.75 2.75 0 0 0 15.25 16v3A2.75 2.75 0 0 0 18 21.75h1A2.75 2.75 0 0 0 21.75 19v-7a9.75 9.75 0 1 0-19.5 0v7A2.75 2.75 0 0 0 5 21.75h1A2.75 2.75 0 0 0 8.75 19v-3A2.75 2.75 0 0 0 6 13.25H3.75V12a8.25 8.25 0 0 1 2.416-5.834ZM3.75 14.75V19A1.25 1.25 0 0 0 5 20.25h1A1.25 1.25 0 0 0 7.25 19v-3A1.25 1.25 0 0 0 6 14.75H3.75Zm16.5 0H18A1.25 1.25 0 0 0 16.75 16v3A1.25 1.25 0 0 0 18 20.25h1A1.25 1.25 0 0 0 20.25 19v-4.25Z",
    clipRule: "evenodd"
  })));
};
export default SvgPodcast;